var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.is_show)?_c('div',{staticClass:"badge-dot badge-class",style:('top:-'+(_vm.size/2)+'px;right:-'+_vm.size+'px;height:'+_vm.size+'px;width:'+_vm.size+'px')}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }